import { GlFormCheckbox, GlModal, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { __ } from '~/locale';
import TransferLocations from './transfer_locations.vue?vue3';
export default {
    name: 'GroupsProjectsTransferModal',
    components: {
        GlModal,
        TransferLocations,
        GlFormCheckbox,
        GlSprintf
    },
    inject: [
        'resourceId',
        'resourceFullPath'
    ],
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        groupTransferLocationsApiMethod: {
            type: Function,
            required: true
        },
        transferApiMethod: {
            type: Function,
            required: true
        },
        showUserTransferLocations: {
            type: Boolean,
            required: false,
            default: true
        },
        additionalDropdownItems: {
            type: Array,
            required: false,
            default () {
                return [];
            }
        }
    },
    emits: [
        'change',
        'success',
        'error'
    ],
    data () {
        return {
            modalId: uniqueId('transfer-modal-'),
            selectedLocation: null,
            isLoading: false,
            urlChangeConfirmed: false
        };
    },
    computed: {
        requireUrlChangeConfirmation () {
            return this.resourceFullPath && this.selectedLocation?.newPath;
        },
        showUrlChangeCheckbox () {
            return this.selectedLocation && this.requireUrlChangeConfirmation;
        },
        isTransferDisabled () {
            if (!this.selectedLocation) return true;
            return Boolean(this.requireUrlChangeConfirmation && !this.urlChangeConfirmed);
        },
        modalActionProps () {
            return {
                primary: {
                    text: __('Transfer'),
                    attributes: {
                        variant: 'danger',
                        disabled: this.isTransferDisabled,
                        loading: this.isLoading
                    }
                },
                cancel: {
                    text: __('Cancel')
                }
            };
        }
    },
    methods: {
        async transferLocation () {
            this.isLoading = true;
            try {
                await this.transferApiMethod(this.resourceId, this.selectedLocation.id);
                this.$emit('success');
            } catch (error) {
                this.$emit('error', error.response?.data?.message || error.message);
            } finally{
                this.isLoading = false;
                this.handleVisibilityChange(false);
            }
        },
        handleVisibilityChange (isVisible) {
            if (!isVisible) this.resetForm();
            this.$emit('change', isVisible);
        },
        resetForm () {
            this.selectedLocation = null;
            this.urlChangeConfirmed = false;
        }
    }
};
